import React from 'react'

import {
  Accordion,
  AutenticacaoContainer,
  InputUnform,
  Spacer,
  Visao
} from 'src/componentes'

import { ContainerDados, ContainerDadosGrande } from '../../styles'

interface AccordionDisciplinaProps {
  disciplina: any
  deveExpandir?: () => boolean
}

export const AccordionDisciplina: React.FC<AccordionDisciplinaProps> = ({
  disciplina,
  deveExpandir
}) => {
  const { visao } = AutenticacaoContainer.useContainer()

  return (
    <Accordion titulo={disciplina?.nome} deveExpandir={deveExpandir}>
      <InputUnform
        name="disciplinaId"
        defaultValue={disciplina.disciplinaId ?? disciplina.id}
        esconder
      />
      <InputUnform
        name="disciplinaNome"
        defaultValue={disciplina.disciplinaNome ?? disciplina.nome}
        esconder
      />

      <Spacer padding="10px 0px" />

      <ContainerDados>
        <ContainerDadosGrande>
          <InputUnform
            name="nota1"
            label="Nota na disciplina"
            disabled={visao !== Visao.ParceiroCertificacao}
            maxLength={200}
          />
        </ContainerDadosGrande>
      </ContainerDados>
    </Accordion>
  )
}
